export const MEETING_STATUSSEN = [
    'UPLOADED',
    'TRANSCRIBING',
    'TRANSCRIBED',
    'CONFIRMED',
    'EXTRACTING',
    'EXTRACTED',
    'DONE',
    'FAILED',
];
export const SENIORITEITEN = ['junior', 'medior', 'senior'];
